module.exports = __webpack_public_path__ + "static/img/Jackson-Ford.15eecf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Jackson-Ford.jpg
// module id = 3fXQ
// module chunks = 0